import React from 'react';
// import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { Link } from 'react-router';
// import Select from 'react-select';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';

const queryOrganizations = gql`
  query organizations {
    organizations {
      id
      name
    }
  }
`;

const withData = graphql(queryOrganizations, {
  options: () => ({
    fetchPolicy: 'network-only',
  }),
});

@withData
@connect()
export default class OrgnizationsList extends React.Component {
  render() {
    const { data: { organizations, loading } } = this.props;
    if (loading) {
      return (
        <div>
          loading <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
        </div>
      );
    }
    if (!organizations) return <div>There are no orgs</div>;

    return (
      <div className="list-group">
        {organizations.map(o => (
          <Link
            to={`/admin/organization/${o.id}`}
            key={o.id}
            className="list-group-item list-group-item-action"
          >
            {o.name}
          </Link>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/OrganizationsList.js